import { ReplySectionCombinedProps } from './types';

const usePresenter = (props: ReplySectionCombinedProps): ReplySectionCombinedProps => {
  return props;
};

export default usePresenter;
